export { FileThumbnail } from './FileThumbnail'
